import { __awaiter } from "tslib";
import React, { createContext, useContext, useEffect, useState } from 'react';
import { requestWrapper } from '../api/requestWrapper';
import { useOrdersClient } from '../hooks/useOrdersClient';
import { RegionEnum, RequestMethodEnum } from '../components/SupportHelpBot/types';
import { isValidNumber, parseIntegerData } from '../utilities/validation';
export const OrdersDataContext = createContext(undefined);
export const OrdersDataStateProvider = ({ children }) => {
    const client = useOrdersClient();
    const [nbUncaptured, setNbUncaptured] = useState(0);
    const [nbUncapturedHasError, setNbUncapturedHasError] = useState(false);
    useEffect(() => {
        const getNbUncaptured = () => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield getNbUncapturedResponse(client);
            const data = response[0].response.data;
            const nbUncaptured = isValidNumber(data) ? parseIntegerData(data) : 0;
            setNbUncaptured(nbUncaptured);
        });
        getNbUncaptured().catch(() => setNbUncapturedHasError(true));
    }, []);
    const contextValue = {
        data: {
            nbUncapturedOrders: {
                value: nbUncaptured,
                hasError: nbUncapturedHasError
            }
        }
    };
    return (React.createElement(OrdersDataContext.Provider, { value: contextValue }, children));
};
export const useOrdersDataState = () => {
    const value = useContext(OrdersDataContext);
    if (!value)
        throw new Error('cannot get OrdersData state manager as it has not been provided');
    return value;
};
const getNbUncapturedResponse = (client) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield requestWrapper(client, RequestMethodEnum.GET, 'count/unfulfilled', '', [RegionEnum.EU]));
});
